import React from 'react';
import { Alert, AlertType } from '../../components/Alert';
import { boldFormatter } from './Formatters/boldFormatter';
import { linkFormatter } from './Formatters/linkFormatter';

interface PropTypes {
  type: AlertType;
  message?: string;
}

// Usage:
// Wrap text in ** to make it bold, e.g. "This is a **bold** message."
// Use [label](url) to create a link, e.g. "Click [here](/path) to continue."
function FormatAlertText(props: { text: string }) {
  const boldFormatted = boldFormatter(props.text);
  const formattedText = boldFormatted.map((node, index) =>
    linkFormatter(node, index),
  );

  return <>{formattedText}</>;
}

export default function FlashAlert(props: PropTypes) {
  return (
    <Alert type={props.type} clearable={true} autoClearTimeout={3000}>
      <FormatAlertText text={props.message} />
    </Alert>
  );
}
